import router from './router'
/**
 * 路由跳转拦截器
 */

router.beforeEach((to, from, next) => {
  next();
})